// extracted by mini-css-extract-plugin
export default {"pageTitle":"pageHeader_pageTitle__NlYAb"};